module.exports = __webpack_public_path__ + "media/images/flags/1x1/mys-e93c43d73348a2b46224ea7d8d820eaa.svg";